export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-2">
          爆料投稿
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">你有瓜，我有平台</p>

        <div className="max-w-2xl mx-auto bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <div className="flex flex-col items-center text-center mb-6">
            <div className="w-16 h-16 rounded-full bg-accent-100 flex items-center justify-center mb-4">
              <i className="ri-mail-send-line text-2xl text-accent-600"></i>
            </div>
            <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">
              你有独家爆料？我们帮你发声
            </h3>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-md">
              无论是明星动态、剧组内幕还是行业猛料，欢迎通过以下方式联系我们。
              我们承诺对报料人信息<strong className="text-primary-600">严格保密</strong>，重大独家爆料提供线索奖励。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            <div className="flex flex-col items-center p-4 bg-background-100 rounded-xl">
              <i className="ri-wechat-line text-2xl text-primary-500 mb-2"></i>
              <span className="text-xs text-foreground-500 mb-1">微信公众号</span>
              <span className="text-sm font-medium text-foreground-900">爆瓜网官方</span>
            </div>
            <div className="flex flex-col items-center p-4 bg-background-100 rounded-xl">
              <i className="ri-weibo-line text-2xl text-primary-500 mb-2"></i>
              <span className="text-xs text-foreground-500 mb-1">微博私信</span>
              <span className="text-sm font-medium text-foreground-900">@爆瓜网</span>
            </div>
            <div className="flex flex-col items-center p-4 bg-background-100 rounded-xl">
              <i className="ri-mail-line text-2xl text-primary-500 mb-2"></i>
              <span className="text-xs text-foreground-500 mb-1">投稿邮箱</span>
              <span className="text-sm font-medium text-foreground-900">tips@baogua.com</span>
            </div>
          </div>

          <div className="text-center">
            <button className="px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer">
              立即投稿
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
            <p className="text-xs text-foreground-400 mt-3">
              投稿后我们的编辑将在24小时内与你取得联系
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}